import { Fragment } from "react";
import Header from "../../components/Header/Header";
import ProgressLoader from "../../components/ProgressLoader/ProgressLoader";
import { Outlet } from "react-router-dom";
import Footer from "../../components/Footer/Footer";

const PublicLayout = () => {
    return (
        <Fragment>
            <Header />
            <Outlet/>
            <ProgressLoader />
            <Footer/>
        </Fragment>
    );
};

export default PublicLayout;
